<div
  class="rt-toast"
  [ngClass]="'rt-toast__'+toast.type"
  [@payAttentionAnimation]="toast.isDuplicate ? 'triggered' : 'none'"
  (@payAttentionAnimation.done)="forgotAboutDuplicate(toast.id!)"
>
  <div
    class="rt-toast__content"
  >
    <div
      class="rt-toast__icon"
      [ngClass]="'rt-toast__icon_'+toast.type"
    ></div>
    <div>
      <div class="rt-toast__title">{{ toast.label }}</div>
      <div class="rt-toast__message" [innerHTML]="toast.message"></div>
    </div>
  </div>
  <div>
    <div
      class="close-icon"
      (click)="closeToast()"
    >
    </div>
    @if (toast.isShowTimeout) {
      <div
        [style.width]="segment * toastTimeout + '%'"
        [style.bottom]="isHoveredContainer ? '-4px' : 0"
        [style.opacity]="isHoveredContainer ? 0.7 : 1"
        class="time-progress"
        [ngClass]="'time-progress__'+toast.type"
      >
      </div>
    }
  </div>
</div>
